var _style, _g, _g2, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProductNotFoundEmptyState(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 160 161",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st5{fill:#282832}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "no_product"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(42.5 32.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(42)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-23"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 0.6,
    y: 0,
    width: 32.1,
    height: 32.1
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 0.6,
    y: 0,
    width: 32.1,
    height: 32.1,
    id: "mask-2_2_"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#Adobe_OpacityMaskFilter)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-1_2_",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#fff",
    d: "M.6 0h32v32.1H.6z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Fill-21",
    d: "M2.5 23C.6 19.8.1 15.8 1 12.2c.9-3.6 3.1-7 6.2-9.1 3-2.2 6.9-3.3 10.6-3 3.8.3 7.4 2 10 4.6 2.7 2.7 4.3 6.3 4.7 10 .3 3.8-.7 7.6-2.9 10.7-2.2 3.1-5.5 5.3-9.1 6.2-1.8.5-3.7.6-5.6.4-1.8-.2-3.6-.8-5.2-1.7-.2-.1-.2-.3-.1-.5s.3-.2.4-.2c3.3 1.3 6.8 1.5 10.1.7 3.3-.9 6.3-2.9 8.2-5.7 1.9-2.8 2.9-6.2 2.6-9.6-.3-3.4-1.8-6.6-4.2-9-2.4-2.4-5.7-3.9-9.1-4.2-3.4-.3-6.8.7-9.6 2.6-2.8 1.9-4.8 4.9-5.7 8.2l-.2.6-.1.6c.1.4 0 .8 0 1.3-.1.9-.1 1.7 0 2.6.1 1.7.5 3.4 1.1 5 .1.2 0 .4-.2.5-.2 0-.4-.1-.4-.2",
    mask: "url(#mask-2_2_)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#302c34"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M22.9 19.1l-3-2.9-.2-.2 3.1-3.2c1.3-1.3 1.7-3 .9-3.7l-.4-.4c-.8-.7-2.4-.3-3.7 1.1l-2.9 3-.2.2-.2-.2-3-2.9c-1.3-1.3-3-1.7-3.7-.9l-.5.4c-.7.8-.3 2.4 1.1 3.7l3.2 3.1-.2.2-2.9 3c-1.3 1.3-1.7 3-.9 3.7l.4.4c.8.7 2.4.3 3.7-1.1l3.1-3.2 3.2 3.1c1.3 1.3 3 1.7 3.7.9l.4-.4c.8-.8.3-2.5-1-3.7z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#aeaec0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Creativita\\u0300---Search---Error",
    transform: "translate(44 126.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-11",
    d: "M71.8 6.1c0 3.4-15.9 6.1-35.6 6.1S.6 9.4.6 6.1 16.5 0 36.2 0s35.6 2.7 35.6 6.1",
    fill: "#ececf6"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "prodotto-02",
    transform: "matrix(-1 0 0 1 63 16.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    className: "st5",
    d: "M15.2 64.6c.5-.6 1.1-1.2 1.6-1.8l.8-.9.2-.2.1-.1.1-.1v-.1l.1-.1.1-.2V61c.1-.2.2-.3.2-.5V58c0-1.1-.1-2.3-.1-3.4s0-2.3-.1-3.4V36v-.1c0-.3-.2-.6-.4-.7-.1-.1-.2-.2-.4-.2H-7.3h-.1c-.1 0-.2 0-.2.1h-.2l-.1.1H-8l.1-.1-.2.1-.1.1c-.1 0-.1.1-.2.2l.2-.1-20.9 20.9-10.5 10.5-.2.2-.1.1c-.1.1-.1.1-.1.2-.1.1-.1.3-.1.4 0 .3.1.6.3.8l2.6 2.6 5.2 5.2 10.5 10.5 5.2 5.2.6.7.2.2.1.1c.1.1.1.1.2.1.1.1.3.1.4.1s.3 0 .5-.1.3-.1.4-.2l.6-.6L-12 91l5.3-5.2 2.6-2.6 2.6-2.6C2 77.2 5.6 73.8 9.3 70.5c.2-.2.5-.2.7 0 .2.2.2.5 0 .7C6.7 74.9 3.3 78.5-.1 82l-2.6 2.6-2.6 2.6-5.2 5.3-1.3 1.3-.7.7c-.3.3-.7.6-1.2.7-.4.2-.9.2-1.3.2-.5 0-.9-.2-1.3-.4-.2-.1-.4-.3-.6-.4l-.1-.1-.1-.1-.2-.2-.7-.6-5.3-5.3-10.5-10.5-5.2-5.2-2.6-2.6c-.7-.7-1-1.6-.9-2.6 0-.5.2-.9.4-1.3.1-.2.3-.4.4-.6 0-.1.1-.1.1-.1l.1-.1.2-.2 10.5-10.5 20.9-20.9c.1-.1.1-.1.2-.1l.1-.1c.1 0 .1-.1.2-.2l-.2.1.2-.2c.1 0 .1-.1.1-.1l.1-.1h.1c.1-.1.2-.1.3-.2.1-.1.2-.1.3-.1.2-.1.4-.1.6-.2h25.3c.2 0 .4.1.6.1.4.1.8.3 1.1.6.7.5 1.1 1.4 1.2 2.2V50.9c0 1.1 0 2.3-.1 3.4 0 1.1 0 2.3-.1 3.4l-.1 1.7v.6c0 .1 0 .2-.1.3-.1.4-.2.7-.5 1.1l.1-.1-.1.7-.1.2-.2.2-.2.2-.1.1-.2.2-.9.8c-.6.5-1.2 1.1-1.8 1.6-.2.2-.5.2-.7-.1-.2-.1-.2-.4 0-.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M4.7 54.6c3.5 0 6.3-2.8 6.3-6.3s-2.8-6.4-6.3-6.4-6.3 2.8-6.3 6.3 2.8 6.4 6.3 6.4zm0-10.7c2.4 0 4.3 1.9 4.3 4.3s-2 4.3-4.3 4.3c-2.4 0-4.3-1.9-4.3-4.3s1.9-4.3 4.3-4.3z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.7 87.1c3.7 3.3 7.2 6.7 10.8 10.1l2.6 2.6 2.6 2.6 5.3 5.2 1.3 1.3.6.6c.1.1.2.2.4.2.2.1.3.1.5.1s.3-.1.4-.1c.1 0 .1-.1.2-.1l.1-.1.2-.2.6-.7 5.2-5.2L95 92.9l5.2-5.2 2.6-2.6c.2-.2.3-.5.3-.8 0-.2-.1-.3-.1-.4 0-.1-.1-.1-.1-.2l-.1-.1-.2-.2-10.4-10.5L71.3 52l-.1-.1-.1-.1-.1-.1.1.1-.1-.1-.1-.1h-.1-.1c-.1 0-.2 0-.2-.1H45.6c-.1 0-.3.1-.4.2-.2.2-.4.4-.4.7v15.3c0 1.1 0 2.3-.1 3.4 0 1.1 0 2.3-.1 3.4l-.1 1.7v.7c0 .2.1.3.2.5v.1l.1.2.1.1v.1l.1.1.1.1.2.2.8.9c.5.6 1.1 1.2 1.6 1.8.2.2.2.5-.1.6l5.3 5.3c.4 0 .6 0 .8.2zm4.6-28.7c3.5 0 6.3 2.8 6.3 6.3S61.8 71 58.3 71 52 68.2 52 64.7c0-3.4 2.8-6.3 6.3-6.3z",
    fill: "#e4e4eb"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductNotFoundEmptyState);
export default __webpack_public_path__ + "static/media/productNotFound_emptyState.9f63348895b4fe2f9cb230d2d70fa0f5.svg";
export { ForwardRef as ReactComponent };